import {post} from "./Http";

/**
 * 校验组织是否存在
 * @param  {[type]}  post [description]
 * @param  {[type]}  name [description]
 * @return {Boolean}      [description]
 */
function isNotExist(name) {
  return post("/ctx-user/v1/org/isNotExist", {'orgName': name})
}

/**
 * 创建组织
 * @param  {[type]} post [description]
 * @param  {[type]} name [description]
 * @return {[type]}      [description]
 */
function create(obj) {
  return post("/ctx-user/v1/org/create", obj)
}

/**
 * 通过id获取组织信息
 * @param  {[type]} post [description]
 * @param  {[type]} id   [description]
 * @return {[type]}      [description]
 */
function getById(id) {
  return post("/ctx-user/v1/org/getById", {id})
}

/**
 * 获取所有组织列表
 * @param  {[type]} post [description]
 * @return {[type]}      [description]
 */
function query(orgName, mobile) {
  return post("/ctx-user/v1/org/query", {orgName, mobile})
}

//删除组织
function deleteOrg(id) {
  return post('/ctx-user/v1/org/delete', {'orgId': id})
}


// 保存更新组织档案
function update(obj) {
  return post('/ctx-user/v1/SetOrg/update', obj)
}

//检测系统设置中组织档案下信用代码和计算机代码是否为空
function isExist(str, code) {
  //code : CreditCode 信用代码   ComputerCode 计算机码
  let identificationCode = str + '_' + code
  return post('/ctx-user/v1/SetOrg/isExist', identificationCode)
}

function createAcc(query){
  return post('/ctx-user/v1/sysOrg/create',query)
}

//新增账套
function createAccount(query){
  return post('/ctx-portal/v1/cailian/insertOrg',query)
}


// 删除帐套
function deleteAccount(query) {
  return post('/ctx-portal/v1/cailian/deleteOrg', {'orgId': query})
}

function accountInit(payload){
  return post('/ctx-user/v1/web/ctx/getDaglList',payload)
}

//账套列表专属
function getAccountList(query) {
  return post('/ctx-user/v1/web/ctx/getZyglList',query)
}

// 根据code获取枚举类型列表 --会计准则列表
function getAccountingStandardsList(code) {
  return post('/ctx-setting/v1/enum/queryByEnumCode', code);
}


// 获取用户所在机构
function getOrgList(query) {
  return post('/ctx-portal/v1/user/queryByService', query);
}

// 切换登录机构
function changeUserOrg(params) {
  return post('ctx-portal/v1/operate/changeUser', params)
}

// 根据账套id查询账套纳税人类型转换历史
function getEveryMonthType(query) {
  return post('ctx-portal/v1/convertHistory/getEveryMonthType', query)
}

export default {
  isNotExist,
  create,
  getById,
  query,
  deleteOrg,
  update,
  isExist,
  createAcc,
  accountInit,
  getAccountList,
  getAccountingStandardsList,
  getOrgList,
  changeUserOrg,
  getEveryMonthType,
  createAccount,
  deleteAccount
}



// WEBPACK FOOTER //
// ./src/api/OrgApi.js